export type AnalyticsEventName =
  | 'cta_signin'
  | 'cta_start_trial'
  | 'form_contact_submit'
  | 'cta_subscribe'
  | 'download_sample_report'
  | 'language_switch'
  | 'outbound_click'
  | 'scroll_depth'
  | 'time_on_page';

export interface AnalyticsEventParams {
  page_path?: string;
  locale?: string;
  company_slug?: string;
  location?: string;
  [key: string]: unknown;
}

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export function pushEvent(
  name: AnalyticsEventName,
  params: AnalyticsEventParams = {},
): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  const payload: Record<string, unknown> = {
    event: name,
    page_path:
      params.page_path ??
      (typeof window.location !== 'undefined'
        ? window.location.pathname + window.location.search
        : undefined),
    locale:
      params.locale ??
      (typeof document !== 'undefined' && document.documentElement.lang
        ? document.documentElement.lang
        : undefined),
    ...params,
  };

  window.dataLayer.push(payload);
}
